import { render } from "./HeadlineChangesTable.vue?vue&type=template&id=adc90e94"
import script from "./HeadlineChangesTable.vue?vue&type=script&lang=js"
export * from "./HeadlineChangesTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__